import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports
import $ from 'jquery'; // eslint-disable-line no-restricted-imports

function TagSuggestionsData() {
    this.defaultAttrs({
        dataSource: null,
        dataList: '[data-tag-editor-data]',
        dataListItem: '[data-tag-editor-data-item]',
    });

    this.fetchRemoteSuggestions = function(query) {
        const self = this;
        $.ajax({
            url: this.attr.dataSource,
            type: 'GET',
            data: { query },
            success(data) {
                self.processSuggestions(data, query);
            },
            error() {
                self.processSuggestions([], query);
            },
        });
    };

    this.getData = function(event, data) {
        const query = data.userString;
        if (query && query.trim()) {
            this.fetchRemoteSuggestions(query);
        } else {
            this.processSuggestions([], '');
        }
    };

    this.processSuggestions = function(suggestions, userString) {
        this.trigger('dataSuggestionsDataServed', {
            userString,
            suggestions,
        });
    };

    this.after('initialize', function() {
        this.on('dataSuggestionsDataRequested', this.getData);
    });
}

export default defineComponent(TagSuggestionsData);



// WEBPACK FOOTER //
// ./src/js/component_data/remote-tag-suggestions.js